import { writable } from 'svelte/store';
import { getWorksites } from './apiWorksites';
import { storeWorksites, storeWorksite } from './worksite';
import { idPageArticle, idPageArticleEdition, idPageChantier, idPageEcosystem, idPageEntreprise, idPageEntreprises, idPageHome, idPageLogin, idPageMembres, idPageModifPassword, idPageMyArticles, idPageNosChantiers, idPageNosLivrables, idPagePartenaire, idPagePlenaries, idPagePress, idPagePressRevue, idPageRealisations, idPageRegistration, idPageResetPassword, idPageUserAccount } from './router2';
import { redirectTo } from './router1';
import { getRedirectionByName } from './apiRedirections';
import { getArticles } from './apiArticles';
import { storeArticle, storeArticles } from './blog';
import { getEnterprises } from './apiEnterprises';
import { storeEnterpriseId, storeEnterprises } from './enterprise';
import { getDeliverables } from './apiDeliverables';
import { storeDeliverables } from './deliverable';
import { getActiveMembers } from './apiUsers';
import { storeUsers } from './user';
import { getEcosystems, getPartners } from './apiEcosystems';
import { storeEcosystems, storePartners, storeEcosystemId } from './ecosystem';
import './store';
import "./api";
export const storeRedirections = writable([]);
export const storeRedirectionsError = writable("");
export const storeRedirection = writable({});
export const emptyRedirection = {
    id: 0,
    redirection_name: "",
    redirection_target: 0,
};
/**
 * redirection
 *
 * Pour une url égale à https://www.cat.com/?redirection=toto
 * Alors on vérifie si une entrée existe dans la table redirections avec un redirection_name==toto
 * Si oui alors on redirige vers la page chantier avec un id de chantier égal à redirection_target
 */
export function redirection() {
    const url = new URL(window.location.href);
    const splitUrl = url.href.split("/");
    let page = "";
    let oldRedirection = false;
    // Redirection chantier
    // https://www.cat.com/?redirection=toto
    const redirection_url = url.searchParams.get("redirection");
    if (redirection_url != undefined && redirection_url != "") {
        oldRedirection = true;
        const returnRedirection = getRedirectionByName(redirection_url);
        storeRedirection.subscribe(redirection => {
            const returnValue = getWorksites();
            storeWorksites.subscribe(worksites => {
                const filteredWorksite = worksites.filter((worksite) => worksite.id == redirection.redirection_target)[0];
                if (filteredWorksite != undefined && filteredWorksite != "") {
                    storeWorksite.set(filteredWorksite);
                    setTimeout(() => { redirectTo(idPageChantier, "?id=" + redirection.redirection_target); }, 500);
                }
            });
        });
    }
    // Redirection article
    // https://www.cat.com/?article=id
    const article_url = url.searchParams.get("article");
    if (article_url != undefined && article_url != "") {
        oldRedirection = true;
        const returnValue = getArticles();
        storeArticles.subscribe(articles => {
            const filteredArticle = articles.filter((article) => article.id == parseInt(article_url))[0];
            if (filteredArticle != undefined && filteredArticle != "") {
                storeArticle.set(filteredArticle);
                setTimeout(() => { redirectTo(idPageArticle, "?id=" + article_url); }, 500);
            }
        });
    }
    if (!oldRedirection && splitUrl.length > 3 && splitUrl[3].length > 0) {
        // url = https://www.truc.com/page?id=n
        const splitPage = splitUrl[3].split("?");
        page = splitPage[0];
        const urlParams = new URLSearchParams(window.location.search);
        updateStoreFromUrl(page, urlParams);
    }
}
function updateStoreFromUrl(page, urlParams) {
    const tempo = 2000;
    let paramUrl = "";
    if (page == idPageArticle) {
        // url = https://www.collectif-api-thinking.com/article?id=n
        const articleId = urlParams.get("id");
        if (articleId != undefined && articleId != "") {
            paramUrl = "?id=" + articleId;
            getArticles();
            storeArticles.subscribe(articles => {
                const filteredArticle = articles.filter((article) => article.id == parseInt(articleId))[0];
                if (filteredArticle != undefined && filteredArticle != "") {
                    storeArticle.set(filteredArticle);
                    setTimeout(() => { redirectTo(page, paramUrl); }, tempo);
                }
                else {
                    setTimeout(() => { redirectTo(idPageHome, ""); }, tempo);
                }
            });
        }
        else {
            setTimeout(() => { redirectTo(idPageHome, ""); }, tempo);
        }
    }
    else if (page == idPageEntreprise) {
        // url = https://www.collectif-api-thinking.com/entreprise?id=n
        const id = urlParams.get("id");
        if (id != undefined && id != "") {
            paramUrl = "?id=" + id;
            getEnterprises();
            storeEnterprises.subscribe(entreprises => {
                const filteredEntreprise = entreprises.filter((entreprise) => entreprise.id == parseInt(id))[0];
                if (filteredEntreprise != undefined && filteredEntreprise != "") {
                    storeEnterpriseId.set(parseInt(id));
                    setTimeout(() => { redirectTo(page, paramUrl); }, tempo);
                }
                else {
                    setTimeout(() => { redirectTo(idPageHome, ""); }, tempo);
                }
            });
        }
        else {
            setTimeout(() => { redirectTo(idPageHome, ""); }, tempo);
        }
    }
    else if (page == idPageChantier) {
        // url = https://www.collectif-api-thinking.com/chantier?id=n
        const id = urlParams.get("id");
        if (id != undefined && id != "") {
            paramUrl = "?id=" + id;
            getEnterprises();
            getWorksites();
            storeWorksites.subscribe(worksites => {
                const filteredWorksite = worksites.filter((worksite) => worksite.id == parseInt(id))[0];
                if (filteredWorksite != undefined && filteredWorksite != "") {
                    storeWorksite.set(filteredWorksite);
                    setTimeout(() => { redirectTo(page, paramUrl); }, tempo);
                }
                else {
                    setTimeout(() => { redirectTo(idPageHome, ""); }, tempo);
                }
            });
        }
    }
    else if (page == idPagePartenaire) {
        // url = https://www.collectif-api-thinking.com/partenaire?id=n
        const id = urlParams.get("id");
        if (id != undefined && id != "") {
            paramUrl = "?id=" + id;
            getPartners();
            storeEcosystemId.set(parseInt(id));
            storePartners.subscribe(partners => {
                setTimeout(() => { redirectTo(page, paramUrl); }, tempo);
            });
        }
        else {
            setTimeout(() => { redirectTo(idPageHome, ""); }, tempo);
        }
    }
    else if (page == idPageNosChantiers) {
        // url = https://www.collectif-api-thinking.com/noschantier
        getEnterprises();
        getWorksites();
        setTimeout(() => {
            storeWorksites.subscribe(worksites => {
                setTimeout(() => { redirectTo(page, ""); }, tempo);
            });
        }, 1000);
    }
    else if (page == idPageEntreprises) {
        // url = https://www.collectif-api-thinking.com/nosentreprises
        getEnterprises();
        setTimeout(() => {
            storeEnterprises.subscribe(entreprises => {
                setTimeout(() => { redirectTo(page, ""); }, tempo);
            });
        }, 1000);
    }
    else if (page == idPageMembres) {
        // url = https://www.collectif-api-thinking.com/nosmembres
        getActiveMembers();
        setTimeout(() => {
            storeUsers.subscribe(users => {
                setTimeout(() => { redirectTo(page, ""); }, tempo);
            });
        }, 1000);
    }
    else if (page == idPageNosLivrables || page == idPagePressRevue || page == idPagePress || page == idPageRealisations || page == idPagePlenaries) {
        // url = https://www.collectif-api-thinking.com/noslivrables
        getDeliverables();
        setTimeout(() => {
            storeDeliverables.subscribe(deliverables => {
                setTimeout(() => { redirectTo(page, ""); }, tempo);
            });
        }, 1000);
    }
    else if (page == idPageEcosystem) {
        // url = https://www.collectif-api-thinking.com/ecosystem
        getEcosystems();
        setTimeout(() => {
            storeEcosystems.subscribe(ecosystem => {
                setTimeout(() => { redirectTo(page, ""); }, tempo);
            });
        }, 1000);
    }
    else if (page == idPageLogin || page == idPageArticleEdition || page == idPageModifPassword || page == idPageMyArticles || page == idPageRegistration || page == idPageResetPassword || page == idPageUserAccount) {
        setTimeout(() => { redirectTo(idPageHome, ""); }, tempo);
    }
    else {
        setTimeout(() => { redirectTo(page, paramUrl); }, tempo);
    }
    return paramUrl;
}
